import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import IconAngleRight from '@adv-mt/mt-svg-icons/lib/ChevronRight.js'

// eslint-disable-next-line react/prop-types
const linkFactoryDefaultProp = ({children, ...rest}) => <a {...rest}>{children}</a>

const defaultLiteralTags = {
  highlightStart: '<strong>',
  highlightEnd: '</strong>',
  smallStart: '<small>',
  smallEnd: '</small>'
}

const ROLE = 'marketed-version'
const MARKETED_VERSION_TITLE_TEST_ID = `${ROLE}-title`
const MARKETED_VERSION_DESCRIPTION_TEST_ID = `${ROLE}-description`

const EMPTY_STRING = ''

const CardMarketedVersion = ({initDate, endDate, price, linkFactory: Link = linkFactoryDefaultProp, url: link}) => {
  const {i18n} = useContext(Context)

  const getTranslatedTitle = ({initDate, endDate}) => {
    const baseLiteral = i18n.t('TECHNICAL_DETAILS_MARKETED_VERSION')
    const initDateLiteral = i18n
      .t('COMMON_FROM_DATE', {
        initDate: `<strong>${initDate}</strong>`
      })
      .toLowerCase()
    const endDateLiteral = endDate
      ? i18n
          .t('COMMON_TO_DATE', {
            endDate: `<strong>${endDate}</strong>`
          })
          .toLowerCase()
      : EMPTY_STRING
    return htmlStringToReactElement(`${baseLiteral} ${initDateLiteral} ${endDateLiteral}`)
  }

  const getTranslatedDescription = ({price: value}) => {
    const price = i18n.c(value)
    return htmlStringToReactElement(
      i18n.t('TECHNICAL_DETAILS_VERSION_PRICE_DESCRIPTION', {
        price,
        ...defaultLiteralTags
      })
    )
  }

  const translatedTitle = getTranslatedTitle({initDate, endDate})
  const translatedDescription = getTranslatedDescription({price})

  return (
    <div className="mt-CardMarketedVersion" role={ROLE}>
      <Link className="mt-CardMarketedVersion-link" href={link}>
        <div className="mt-CardMarketedVersion-inner">
          <p className="mt-CardMarketedVersion-innerTitle" data-testid={MARKETED_VERSION_TITLE_TEST_ID}>
            {translatedTitle}
          </p>
          <p className="mt-CardMarketedVersion-innerDescription" data-testid={MARKETED_VERSION_DESCRIPTION_TEST_ID}>
            {translatedDescription}
          </p>
        </div>
        <IconAngleRight svgClass="mt-CardMarketedVersion-icon" className="mt-CardMarketedVersion-icon" />
      </Link>
    </div>
  )
}

CardMarketedVersion.displayName = 'CardMarketedVersion'

CardMarketedVersion.propTypes = {
  initDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  price: PropTypes.number.isRequired,
  linkFactory: PropTypes.func,
  url: PropTypes.string.isRequired
}

export default CardMarketedVersion
